module.exports = __webpack_public_path__ + "static/media/follow.061917b2.svg";